<!--app-header [mode]="'offerpack'"></app-header-->
<ng-container *ngIf="isBrowser">
    <app-header></app-header>
    <ng-container *ngTemplateOutlet="desktopTemplate ? desktopmode : mobilemode"></ng-container>
    <footer></footer>
</ng-container>

<ng-template #desktopmode>
    <div style="display: flex;align-items: center;min-height: 60px;background-color: #edf2f5;">
        <ng-container *ngTemplateOutlet="actionsnavdesk"></ng-container>
    </div>
    <ng-container *ngIf="showPacklistForcustomer">
        <div style="display: flex;align-items: center;min-height: 60px;background-color:#f7f9fb;">
            <ng-container *ngTemplateOutlet="mypacklists"></ng-container>
        </div>
    </ng-container>
    <div
        style="color:#545454;width: 100%;max-width: 1340px;margin: 0 auto;display: flex;flex-direction: column;margin-top: .3rem;">
        <ng-container *ngTemplateOutlet="offerlist"></ng-container>
    </div>
</ng-template>

<ng-template #mobilemode>
    <ng-container *ngIf="packpartner?.email">
        <div style="display: flex;align-items: center;margin: .5rem;">
            <app-avatar [data]="packpartner.avatar"></app-avatar>
            <div
                style="display: flex;flex-direction: column;margin: .5rem;padding: .5rem;font-size: .9rem;font-weight: 500;">
                <span multilang>{{packpartner?.salutation}} {{packpartner?.firstname}}
                    {{packpartner?.lastname}}</span>
                <span multilang>{{packpartner?.tel}}</span>
                <span multilang>{{packpartner?.email}}</span>
                <span multilang>{{packpartner?.description}}</span>
            </div>
        </div>
    </ng-container>
    <div style="color:#545454;width: 100%;display: flex;flex-direction: column;">
        <ng-container *ngTemplateOutlet="actionsnavmobile"></ng-container>
        <ng-container *ngIf="showPacklistForcustomer">
            <div style="display: flex;align-items: center;min-height: 60px;background-color:#dbe5ea;">
                <ng-container *ngTemplateOutlet="mypacklists"></ng-container>
            </div>
        </ng-container>
        <ng-container *ngTemplateOutlet="offerlist"></ng-container>
    </div>
</ng-template>


<ng-template #actionsnavdesk>
    <div style="display: flex;flex-direction: column;margin: 0 auto;width: 100%;max-width: 1335px">
        <ng-container *ngIf="packpartner?.email?.length > 0">
            <div style="display: flex;align-items: center;justify-content: space-between;">
                <div style="display: flex;align-items: center;">
                    <app-avatar [data]="packpartner?.avatar"></app-avatar>
                    <div
                        style="display: flex;flex-direction: column;margin: .5rem;padding: .5rem;font-size: .9rem;font-weight: 500;">
                        <span multilang>{{packpartner?.salutation}} {{packpartner?.firstname}}
                            {{packpartner?.lastname}}</span>
                        <span multilang>{{packpartner?.tel}}</span>
                        <span multilang>{{packpartner?.email}}</span>
                        <span multilang>{{packpartner?.description}}</span>
                    </div>
                </div>
            </div>
            <mat-divider></mat-divider>
        </ng-container>
        <div style="display: flex;align-items: center;justify-content: space-between;margin: .5rem 0;">
            <ng-container *ngTemplateOutlet="myofferpackidDesk"></ng-container>
            <ng-container *ngIf="currentCustomer?.asPartner">
                <div style="display: flex;align-items: center;" class="clicable">
                    <ng-container *ngTemplateOutlet="mycustsearchDesk"></ng-container>
                    <ng-container *ngTemplateOutlet="myactionsDesk"></ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #actionsnavmobile>
    <div style="display: flex;align-items: center;flex-wrap: wrap;">
        <ng-container *ngTemplateOutlet="myofferpackidMobile"></ng-container>
        <ng-container *ngIf="currentCustomer?.asPartner">
            <div style="display: flex;align-items: center;width:100%;" class="clicable">
                <ng-container *ngTemplateOutlet="mycustsearchMobile"></ng-container>
                <ng-container *ngTemplateOutlet="myactionsMobile"></ng-container>
            </div>
            <ng-container *ngIf="selectedCustomer?.lastname?.length > 0">
                <span multilang style="padding: .3rem .5rem;width: 100%;">{{selectedCustomer?.lastname + ' ' +
                    selectedCustomer?.firstname}}</span>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #offerlist>
    <ng-container *ngIf="offerPack?.extracomment?.length > 0">
        <pre class="pree">{{offerPack?.extracomment}}</pre>
    </ng-container>
    <div style=" display: flex;overflow: hidden;flex-wrap: wrap;">
        <div style="position: relative;display: flex;" [style.width]="width"
            *ngFor="let off of offerPack?.packlist;let k=index;trackBy: trackByFn;">
            <ng-container [ngSwitch]="off?.type">
                <ng-container *ngSwitchCase="'krz'">
                    <ng-container *ngTemplateOutlet="krzoffer; context: {offer: off, index:k}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'ftiticketshop'">
                    <ng-container *ngTemplateOutlet="ftiticketshop; context: {offer: off, index:k}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'cockpit'">
                    <ng-container *ngTemplateOutlet="cockpit; context: {offer: off, index:k}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'bookingcom'">
                    <ng-container *ngTemplateOutlet="bookingcom; context: {offer: off, index:k}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'hometogo'">
                    <ng-container *ngTemplateOutlet="hometogo; context: {offer: off, index:k}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'ratehawk'">
                    <ng-container *ngTemplateOutlet="ratehawk; context: {offer: off, index:k}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'profewo'">
                    <ng-container *ngTemplateOutlet="profewo; context: {offer: off, index:k}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'getyourguide'">
                    <ng-container *ngTemplateOutlet="getyourguide; context: {offer: off, index:k}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'chamaeleon'">
                    <ng-container *ngTemplateOutlet="chamaeleon; context: {offer: off, index:k}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <ng-container *ngTemplateOutlet="trafficsoffer; context: {offer: off, index:k}"></ng-container>
                </ng-container>
            </ng-container>

        </div>
    </div>
</ng-template>

<ng-template #trafficsoffer let-off="offer" let-k="index">
    <div style="margin:.5rem; display: flex;width: 100%;">
        <app-offerpackcard [offerid]="off?.offerid ? off.offerid : off" [reference]="reference" [index]="k+1"
            style="width: 100%;display: flex;" (removeFromList)="removeFromList($event)"
            (changeindex)="changeindex($event)"></app-offerpackcard>
    </div>
</ng-template>

<ng-template #krzoffer let-off="offer" let-k="index">
    <div style="margin:.5rem;">
        <app-offerpackcruisecard [offerid]="off?.offerid ? off.offerid : off" [reference]="reference" [index]="k+1"
            (removeFromList)="removeFromList($event)" (changeindex)="changeindex($event)"></app-offerpackcruisecard>
    </div>
</ng-template>

<ng-template #ftiticketshop let-off="offer" let-k="index">
    <div style="margin:.5rem;">
        <app-offerpackftiticketshopcard [index]="k+1" [offerid]="off.offerid" [online]="off.online"
            (removeFromList)="removeFromList($event)" (changeindex)="changeindex($event)"
            [mitEmail]="offerPack?.partner?.email" [packid]="offerPack?.packid"
            [mitName]="offerPack?.partner?.firstname + ' ' + offerPack?.partner?.lastname"
            [mitTel]="offerPack?.partner?.tel">
        </app-offerpackftiticketshopcard>
    </div>
</ng-template>

<ng-template #cockpit let-off="offer" let-k="index">
    <div style="margin:.5rem;">
        <clever-offerpackcockpitcard [index]="k+1" [offerid]="off.offerid" [online]="off.online"
            (removeFromList)="removeFromList($event)" (changeindex)="changeindex($event)"
            [mitEmail]="offerPack?.partner?.email" [packid]="offerPack?.packid"
            [mitName]="offerPack?.partner?.firstname + ' ' + offerPack?.partner?.lastname"
            [mitTel]="offerPack?.partner?.tel">
        </clever-offerpackcockpitcard>
    </div>
</ng-template>

<ng-template #bookingcom let-off="offer" let-k="index">
    <div style="margin:.5rem;">
        <clever-offerpackbookingcomcard [index]="k+1" [offerid]="off.offerid" (removeFromList)="removeFromList($event)"
            (changeindex)="changeindex($event)">
        </clever-offerpackbookingcomcard>
    </div>
</ng-template>

<ng-template #profewo let-off="offer" let-k="index">
    <div style="margin:.5rem;">
        <clever-offerpackprofewocard [index]="k+1" [offerid]="off.offerid" [online]="off.online"
            (removeFromList)="removeFromList($event)" (changeindex)="changeindex($event)"
            [mitEmail]="offerPack?.partner?.email" [packid]="offerPack?.packid"
            [mitName]="offerPack?.partner?.firstname + ' ' + offerPack?.partner?.lastname"
            [mitTel]="offerPack?.partner?.tel">
        </clever-offerpackprofewocard>
    </div>
</ng-template>

<ng-template #hometogo let-off="offer" let-k="index">
    <div style="margin:.5rem;">
        <clever-offerpackedomizilcard [index]="k+1" [offerid]="off.offerid" [online]="off.online"
            (removeFromList)="removeFromList($event)" (changeindex)="changeindex($event)" [reference]="reference"
            [mitEmail]="offerPack?.partner?.email" [packid]="offerPack?.packid"
            [mitName]="offerPack?.partner?.firstname + ' ' + offerPack?.partner?.lastname"
            [mitTel]="offerPack?.partner?.tel">
        </clever-offerpackedomizilcard>
    </div>
</ng-template>

<ng-template #ratehawk let-off="offer" let-k="index">
    <div style="margin:.5rem;">
        <clever-offerpackratehawkcard [index]="k+1" [offerid]="off.offerid" [online]="off.online"
            (removeFromList)="removeFromList($event)" (changeindex)="changeindex($event)" [reference]="reference"
            [mitEmail]="offerPack?.partner?.email" [packid]="offerPack?.packid"
            [mitName]="offerPack?.partner?.firstname + ' ' + offerPack?.partner?.lastname"
            [mitTel]="offerPack?.partner?.tel">
        </clever-offerpackratehawkcard>
    </div>
</ng-template>

<ng-template #getyourguide let-off="offer" let-k="index">
    <div style="margin:.5rem;">
        <clever-offerpackgetyourguidecard [index]="k+1" [offerid]="off.offerid" [online]="off.online"
            (removeFromList)="removeFromList($event)" (changeindex)="changeindex($event)"
            [mitEmail]="offerPack?.partner?.email" [packid]="offerPack?.packid"
            [mitName]="offerPack?.partner?.firstname + ' ' + offerPack?.partner?.lastname"
            [mitTel]="offerPack?.partner?.tel">
        </clever-offerpackgetyourguidecard>
    </div>
</ng-template>

<ng-template #chamaeleon let-off="offer" let-k="index">
    <div style="margin:.5rem;">
        <clever-offerpackchamaeleoncard [index]="k+1" [offerid]="off.offerid" [online]="off.online"
            (removeFromList)="removeFromList($event)" (changeindex)="changeindex($event)"
            [mitEmail]="offerPack?.partner?.email" [packid]="offerPack?.packid"
            [mitName]="offerPack?.partner?.firstname + ' ' + offerPack?.partner?.lastname"
            [mitTel]="offerPack?.partner?.tel">
        </clever-offerpackchamaeleoncard>
    </div>
</ng-template>

<ng-template #mycustsearchDesk>
    <div style="display: flex;align-items: center;">
        <ng-container *ngIf="selectedCustomer?.lastname?.length > 0">
            <span multilang>{{selectedCustomer?.lastname + ' ' + selectedCustomer?.firstname}}</span>
        </ng-container>
        <button mat-icon-button *ngIf="showPacklistForcustomer" (click)="offerpacklistForCustomer()"
            matTooltip="Aktualisieren">
            <mat-icon>refresh</mat-icon>
        </button>
        <button mat-icon-button (click)="openPackList()" matTooltip="Versendete Angebote">
            <mat-icon>view_headline</mat-icon>
        </button>
        <input type="text" multilang deeplMode='placeholder' placeholder="Kunde oder Email" matInput
            [(ngModel)]="searchtarget" (ngModelChange)="searchData($event)" [matAutocomplete]="auto"
            style="width: 270px;height: 35px;border: 1px solid #ced4da;padding: 0 .75rem;background-color: #fff;">
        <!--ng-container
            *ngIf="currentCustomer.email === 'barseghyan.arman1@gmail.com' || currentCustomer.email === 'c.helbling@sunfly.de'">
            <ng-container *ngTemplateOutlet="impoertbtn"></ng-container>
        </ng-container-->
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selectedCustomerF($event)">
            <mat-option *ngFor="let data of myCustomersfilteredOptions" [value]="data?.email"
                style="height: 50px;line-height: 20px;">
                <div style="width: 100%;display: flex;flex-direction: column;">
                    <span multilang style="width: 100%;font-weight: 400;color:#545454;">{{data?.lastname}}
                        {{data?.firstname}}</span>
                    <span multilang style="width: 100%;font-size: .7rem;">{{data?.email}}</span>
                </div>
            </mat-option>
        </mat-autocomplete>
    </div>
</ng-template>

<ng-template #mycustsearchMobile>
    <div style="width: 100%;padding-left: .5rem;display: flex;">
        <input type="text" multilang deeplMode='placeholder' placeholder="Kunde" matInput [(ngModel)]="searchtarget"
            (ngModelChange)="searchData($event)" [matAutocomplete]="auto"
            style="width:100%;height: 34px;border: 1px solid #ced4da;padding: .375rem .75rem;">
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selectedCustomerF($event)">
            <mat-option *ngFor="let data of myCustomersfilteredOptions" [value]="data?.email"
                style="height: 50px;line-height: 20px;">
                <div style="width: 100%;display: flex;flex-direction: column;">
                    <span multilang style="width: 100%;font-weight: 400;color:#545454;">{{data?.lastname}}
                        {{data?.firstname}}</span>
                    <span multilang style="width: 100%">{{data?.email}}</span>
                </div>
            </mat-option>
        </mat-autocomplete>
    </div>
</ng-template>

<ng-template #myofferpackidDesk>
    <div style="display: flex;align-items: center;">
        <input type="text" multilang deeplMode='placeholder' placeholder="Angebot ID"
            style="width: 205px;height: 35px;border: 1px solid #ced4da;padding: .375rem .75rem;"
            [(ngModel)]="offerPack.packid" (keypress)="gotoGetPack($event)">

        <ng-container
            *ngIf="currentCustomer?.asPartner && offerPack?.packlist?.length > 0 && (!offerPack?.packid || offerPack?.packid?.length === 0)">
            <button mat-icon-button (click)="createLink()" matTooltip="Link erstellen">
                <mat-icon>link</mat-icon>
            </button>
        </ng-container>

        <ng-container *ngIf="offerPack.packid?.length > 0">
            <app-share [shareLink]="shareLink" [onlyicon]="true" style="margin-left: .5rem;"></app-share>
            <app-offerpdf [offerpack]="offerPack"></app-offerpdf>
        </ng-container>
        <ng-container *ngIf="offerPack?.customerzoomurl?.length > 0">
            <button mat-icon-button (click)="openZoomForCustomer()" matTooltip="Video chat starten"
                [disabled]="currentCustomer?.asPartner">
                <mat-icon>videocam</mat-icon>
            </button>
        </ng-container>
    </div>
</ng-template>

<ng-template #myofferpackidMobile>
    <div style="display: flex;padding: .5rem .5rem 0;width: 100%;align-items:center;">
        <input type="text" multilang deeplMode='placeholder' placeholder="Angebot ID"
            style="width: 100%;height: 34px;border: 1px solid #ced4da;padding: .375rem .75rem;"
            [(ngModel)]="offerPack.packid" (keypress)="gotoGetPack($event)">
        <ng-container *ngIf="offerPack.packid?.length > 0">
            <button mat-icon-button (click)="copylink()" matTooltip="Link kopieren">
                <mat-icon>content_copy</mat-icon>
            </button>
        </ng-container>
        <ng-container *ngIf="offerPack?.customerzoomurl?.length > 0">
            <button mat-icon-button (click)="openZoomForCustomer()" matTooltip="Video chat starten"
                [disabled]="currentCustomer?.asPartner">
                <mat-icon>videocam</mat-icon>
            </button>
        </ng-container>
    </div>
</ng-template>

<ng-template #myactionsDesk>
    <button class="actionBtn" (click)="sendToClient()" *ngIf="this.selectedCustomer?.email?.length > 0"
        matTooltip="Angebot senden" matTooltipClass="matTooltip">
        <mat-icon>send</mat-icon>
    </button>
    <ng-container *ngIf="offerPack.packid?.length > 0">

        <button class="actionBtn" (click)="openSetComment()" matTooltip="Extra info" matTooltipClass="matTooltip">
            <mat-icon>comment</mat-icon>
        </button>
        <ng-container *ngIf="offerPack?.partnerzoomurl?.length > 0">
            <button class="actionBtn" (click)="openZoomForPartner()" matTooltip="Video chat starten"
                matTooltipClass="matTooltip">
                <mat-icon>videocam</mat-icon>
            </button>
        </ng-container>
        <ng-container *ngIf="!offerPack?.customerzoomurl || offerPack?.customerzoomurl?.length === 0">
            <button class="actionBtn" (click)="createZoom()" matTooltip="Zoom erstellen" matTooltipClass="matTooltip"
                *ngIf="!createzoomloading; else myloading">
                <mat-icon>video_call</mat-icon>
            </button>
        </ng-container>

        <button class="actionBtn" (click)="resetpackliste()" matTooltip="Neues Angebot" matTooltipClass="matTooltip">
            <mat-icon>post_add</mat-icon>
        </button>
        <button class="actionBtn" (click)="saveList()" *ngIf="offerPack?.packid?.length > 0" matTooltip="Speichern"
            matTooltipClass="matTooltip">
            <mat-icon>save</mat-icon>
        </button>
    </ng-container>
    <button (click)="resetpackliste()" *ngIf="offerPack?.packid?.length > 0" matTooltip="Schließen"
        matTooltipClass="matTooltip">
        <mat-icon>close</mat-icon>
    </button>
    <button class="actionBtn" style="color: red;" *ngIf="offerPack?.packid?.length > 0" (click)="angebotLeern()"
        matTooltip="Angebote leeren" matTooltipClass="matTooltip">
        <mat-icon>delete</mat-icon>
    </button>
</ng-template>

<ng-template #myactionsMobile>
    <button mat-icon-button (click)="openPackList()" matTooltip="Versendete Angebote">
        <mat-icon>view_headline</mat-icon>
    </button>
    <button mat-icon-button [matMenuTriggerFor]="actionmenu">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #actionmenu="matMenu">
        <button mat-menu-item (click)="sendToClient()">
            <mat-icon>send</mat-icon>
            <span multilang>Angebot senden</span>
        </button>
        <ng-container *ngIf="offerPack.packid?.length > 0">
            <button mat-menu-item (click)="createZoom()">
                <mat-icon>video_call</mat-icon>
                <span multilang>Zoom erstellen</span>
            </button>
            <button mat-menu-item (click)="openSetComment()">
                <mat-icon>comment</mat-icon>
                <span multilang>Extra info</span>
            </button>
            <button mat-menu-item (click)="resetpackliste()">
                <mat-icon>post_add</mat-icon>
                <span multilang>Neues Angebot</span>
            </button>
            <button mat-menu-item (click)="saveList()">
                <mat-icon>save</mat-icon>
                <span multilang>Speichern</span>
            </button>
        </ng-container>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="resetpackliste()">
            <mat-icon>close</mat-icon>
            <span multilang>Schließen</span>
        </button>
        <button mat-menu-item (click)="removeOffers()">
            <mat-icon>delete</mat-icon>
            <span multilang>Angebote leeren</span>
        </button>
    </mat-menu>
</ng-template>

<ng-template #myloading>
    <div style="height: 40px;width: 40px;display: flex;align-items: center;justify-content: center;">
        <mat-spinner diameter="20"></mat-spinner>
    </div>
</ng-template>

<ng-template #mypacklists>
    <div style="display: flex;flex-direction: column;margin: 0 auto;width: 100%;overflow: auto;max-width: 1340px;">
        <ng-container *ngTemplateOutlet="loadingpackforcustomer ? myloading : packlistforcustomer"></ng-container>
    </div>
</ng-template>

<ng-template #packlistforcustomer>
    <mat-list role="list" *ngIf="selectedCustomerPackList?.length > 0">
        <table style="width: 100%;">
            <thead>
                <tr>
                    <th class="cc1" (click)="sortCustomerlist('customer.lastname')">
                        Name
                        <mat-icon *ngIf="sortItem === 'customer.lastname' && sortrdirection === 1"
                            style="transform: translate(0px, 6px);">expand_less</mat-icon>
                        <mat-icon *ngIf="sortItem === 'customer.lastname' && sortrdirection === -1"
                            style="transform: translate(0px, 6px);">expand_more</mat-icon>
                        <mat-icon></mat-icon>
                    </th>
                    <th class="cc1" (click)="sortCustomerlist('customer.firstname')">
                        Vorname
                        <mat-icon *ngIf="sortItem === 'customer.firstname' && sortrdirection === 1"
                            style="transform: translate(0px, 6px);">expand_less</mat-icon>
                        <mat-icon *ngIf="sortItem === 'customer.firstname' && sortrdirection === -1"
                            style="transform: translate(0px, 6px);">expand_more</mat-icon>
                        <mat-icon></mat-icon>
                    </th>
                    <th class="cc1" (click)="sortCustomerlist('customer.email')">
                        Email
                        <mat-icon *ngIf="sortItem === 'customer.email' && sortrdirection === 1"
                            style="transform: translate(0px, 6px);">expand_less</mat-icon>
                        <mat-icon *ngIf="sortItem === 'customer.email' && sortrdirection === -1"
                            style="transform: translate(0px, 6px);">expand_more</mat-icon>
                        <mat-icon></mat-icon>
                    </th>
                    <th class="cc1 tm50" (click)="sortCustomerlist('packid')">
                        Pack ID
                        <mat-icon *ngIf="sortItem === 'packid' && sortrdirection === 1"
                            style="transform: translate(0px, 6px);">expand_less</mat-icon>
                        <mat-icon *ngIf="sortItem === 'packid' && sortrdirection === -1"
                            style="transform: translate(0px, 6px);">expand_more</mat-icon>
                        <mat-icon></mat-icon>
                    </th>
                    <th class="cc1" (click)="sortCustomerlist('partner.email')">
                        Mitarbeiter
                        <mat-icon *ngIf="sortItem === 'partner.email' && sortrdirection === 1"
                            style="transform: translate(0px, 6px);">expand_less</mat-icon>
                        <mat-icon *ngIf="sortItem === 'partner.email' && sortrdirection === -1"
                            style="transform: translate(0px, 6px);">expand_more</mat-icon>
                        <mat-icon></mat-icon>
                    </th>
                    <th class="cc1" (click)="sortCustomerlist('date')">
                        Datum
                        <mat-icon *ngIf="sortItem === 'date' && sortrdirection === 1"
                            style="transform: translate(0px, 6px);">expand_less</mat-icon>
                        <mat-icon *ngIf="sortItem === 'date' && sortrdirection === -1"
                            style="transform: translate(0px, 6px);">expand_more</mat-icon>
                        <mat-icon></mat-icon>
                    </th>
                    <th style="border-bottom: 1px solid #d0d5d7;"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let offpck of selectedCustomerPackList;">
                    <td>{{offpck?.customer?.lastname}}</td>
                    <td>{{offpck?.customer?.firstname}}</td>
                    <td>{{offpck?.customer?.email}}</td>
                    <td class="mw50">{{offpck?.packid}}</td>
                    <td>{{offpck?.partner.firstname}} {{offpck?.partner.lastname}}</td>
                    <td>{{offpck.date | date:'medium'}}</td>
                    <td>
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <!--mat-icon>visibility</mat-icon-->
                            <mat-icon
                                [matTooltip]="'Gesendet ' + (offpck.sendeddate?.length > 0 ? (offpck.sendeddate | date:'medium') : '')"
                                *ngIf="offpck.sended" style="margin-left: 0.3rem;">mark_email_read</mat-icon>
                            <mat-icon matTooltip="Noch nicht gesendet" *ngIf="!offpck.sended"
                                style="margin-left: 0.3rem;opacity: .5;">email</mat-icon>
                            <mat-icon style="margin-left: 0.3rem;" *ngIf="offpck.seen"
                                [matTooltip]="'Gesehen ' + (offpck.sendeddate?.length > 0 ? (offpck.sendeddate | date:'medium') : '')">
                                visibility</mat-icon>
                            <mat-icon matTooltip="Noch nicht gesehen" style="margin-left: 0.3rem;opacity: .5;"
                                *ngIf="!offpck.seen">visibility_off</mat-icon>
                            <mat-icon style="color:seagreen;cursor:pointer;margin-left: 0.3rem;"
                                (click)="gotoSelectedPack(offpck)" matTooltip="Offnen">launch</mat-icon>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <mat-divider></mat-divider>
        <div style="display: flex;padding: .5rem;align-items: center;">
            <span multilang style="margin: 0 4px 0 0;">{{skip + " - " + (totalOfofferpacklistcount > limit ? limit
                :
                totalOfofferpacklistcount)}}</span>
            <span multilang>von {{totalOfofferpacklistcount}}</span>
            <mat-icon class="clicable" *ngIf="skip > 0" (click)="previous()">keyboard_arrow_left
            </mat-icon>
            <mat-icon class="clicable" *ngIf="totalOfofferpacklistcount > limit" (click)="next()">
                keyboard_arrow_right</mat-icon>
        </div>
    </mat-list>
    <span multilang *ngIf="selectedCustomerPackList?.length === 0">Kein Angebote gefunden</span>
</ng-template>


<ng-template #impoertbtn>
    <div>
        <ng-container *ngIf="!importloading else myloading">
            <button mat-icon-button aria-label="import from externe tools" matTooltip="Importieren"
                (click)="importFromExtern()">
                <mat-icon>download</mat-icon>
            </button>
        </ng-container>
    </div>
</ng-template>